$(document).ready(function () {
 var plan = $('option:selected',$('.airtime-services select')).data('handle');
 $('.'+plan).show();

 $('.airtime-services select').change(function(){
	var plan = $('option:selected',$('.airtime-services select')).data('handle');
	var product_price = parseFloat($('#product-variant').data('price'))
	var plan_price = parseFloat($('option:selected',$('.airtime-services select')).data('price'))
	$('.plan').hide();
 	$('.'+plan).show(); 	
 	$('.total span').text('$'+(product_price+plan_price).formatMoney(2,'.',','))
 });

 $('#AddToCart-product-template-subscription').click(function(e){
 	e.preventDefault()
 	var product_id = $('#product-variant').attr('value');
 	var plan_id = $('option:selected',$('.airtime-services select')).data('variant');
    var plan_name = $('option:selected',$('.airtime-services select')).val();
    console.log('plan:'+plan_id+"prod:"+product_id)
 	
 	CartJS.addItem(product_id,1,{"Plan Subscription": plan_name},{
        "success": function(data, textStatus, jqXHR) {
                CartJS.addItem(plan_id,1,{},{
                    "success": function(data, textStatus, jqXHR) {
                       window.location='/cart'
                    }
                });
            }
    });
    
 });
});

Number.prototype.formatMoney = function(c, d, t){
var n = this, 
    c = isNaN(c = Math.abs(c)) ? 2 : c, 
    d = d == undefined ? "." : d, 
    t = t == undefined ? "," : t, 
    s = n < 0 ? "-" : "", 
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };